import { useMutation } from 'react-query';

import { checkValidPinCode } from '../services';

export const useValidatePin = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: string) => void;
}) => {
  return useMutation({
    mutationFn: checkValidPinCode,
    onSuccess,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any) => {
      const message = error?.response?.data?.payload?.message;
      let errorText = message || 'Something went wrong...';

      if (message === 'registration/pincode-not-valid') {
        errorText = 'Pincode is not valid';
      }

      onError?.(errorText);
    },
  });
};
